import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { getAutomatedReportsQueryOptions } from '~/hooks/queries/useAutomatedReportQuery';
import { SessionPlQueryReturnData } from '~/services/ClientServiceTS';
import { getAccountDetailsFromURL } from '~/utils/utils';
import { perms } from './perms';
import { requirePerm } from './requirePerm';
import { sessionContext } from './sessionContext';

function getAutomatedReportingBasePath(sessionData: SessionPlQueryReturnData) {
  const { accountType } = sessionData;
  const accountId = sessionData.id;
  if (sessionData.isPartner) {
    return `/${accountType}/${accountId}/automated-reporting`;
  }
  return `/${accountType}/${accountId}/account/automated-reporting`;
}

function isAutomatedReportingCreateRoute(request: Request) {
  const { pathname } = new URL(request.url);
  return pathname.endsWith('/automated-reporting/new');
}

export const automatedReportingLoader = (queryClient: QueryClient) => {
  return async (ctx: LoaderFunctionArgs) => {
    await requirePerm(perms.analytics)(ctx);
    const sessionData = ctx.context.get(sessionContext);

    if (!perms.automatedReporting({ sessionPlData: sessionData })) {
      const url = new URL(ctx.request.url);
      const { accountType, accountId } = getAccountDetailsFromURL(url.pathname) ?? {};
      throw redirect(`/${accountType}/${accountId}/forbidden`);
    }

    await queryClient.fetchQuery(
      getAutomatedReportsQueryOptions(sessionData.isPartner, sessionData.id),
    );

    if (
      isAutomatedReportingCreateRoute(ctx.request) &&
      !perms.automatedReportingCreate({ sessionPlData: sessionData })
    ) {
      throw redirect(getAutomatedReportingBasePath(sessionData));
    }

    return sessionData;
  };
};
